import React from "react";
import { createRoot } from "react-dom/client";

export function renderPopupContainer(content) {
    const container = document.createElement("div");

    if (typeof content === "string") {
        container.innerHTML = content;
        return container;
    }

    if (React.isValidElement(content)) {
        createRoot(container).render(content);
        return container;
    }

    container.textContent = String(content);
    return container;
}